import { render, staticRenderFns } from "./checkout-bonuses.vue?vue&type=template&id=61c98980&"
import script from "./checkout-bonuses.vue?vue&type=script&lang=js&"
export * from "./checkout-bonuses.vue?vue&type=script&lang=js&"
import style0 from "./checkout-bonuses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c98980')) {
      api.createRecord('61c98980', component.options)
    } else {
      api.reload('61c98980', component.options)
    }
    module.hot.accept("./checkout-bonuses.vue?vue&type=template&id=61c98980&", function () {
      api.rerender('61c98980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-bonuses.vue"
export default component.exports